export const hexToRgba = (hex: string, opacity: number): string => {
  // Remove the '#' if present
  const cleanHex = hex.startsWith("#") ? hex.slice(1) : hex;

  // Parse the red, green, and blue components
  const r = parseInt(cleanHex.substring(0, 2), 16);
  const g = parseInt(cleanHex.substring(2, 4), 16);
  const b = parseInt(cleanHex.substring(4, 6), 16);

  // Return the rgba string
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};
